import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';
import formatPrice from '../../../helpers/formatPrice';
import 'react-loading-skeleton/dist/skeleton.css';

function CreditCardNoEntry() {
  const payments = useSelector((state) => state.payments);

  const { totalDiscountPercentage, creditCardNoEntry } = payments;

  const skeletonLoading = () => (
    <div className="mt-3">
      <Skeleton count={2} height="35px" width="50%" />
      <Skeleton style={{ marginLeft: '50%' }} count={2} height="35px" width="50%" />
    </div>
  );

  return (
    <td
      id="no-entry"
      className={`d-block credit-card-info ${totalDiscountPercentage === 0 ? 'mt-3' : ''}`}
    >
      {
        creditCardNoEntry.length === 0
          ? skeletonLoading()
          : (
            <>
              <div
                style={{ borderBottom: '1px solid gray', paddingTop: `${totalDiscountPercentage === 0 ? '2%' : '6%'}` }}
                className="d-flex justify-content-between align-items-center mb-2"
              >
                <p className={`blue ${totalDiscountPercentage > 0 ? 'mt-1' : 'mt-3'}`}>
                  Entrada:
                </p>
                <p className={`blue strong text-align-end ${totalDiscountPercentage > 0 ? 'mt-1' : 'mt-3'}`}>
                  {formatPrice(0)}
                </p>
              </div>
              <div className="d-flex justify-content-between align-items-start">
                <p className="mt-1">Cartão de Crédito:</p>
                <div style={{ width: '58%', lineHeight: '24px' }}>
                  {
                  totalDiscountPercentage > 0
                  && (
                    <p className="text-align-end payment mt-0">
                      <span className="small">{`de ${creditCardNoEntry[0].quantity}x `}</span>
                      <span className="text-decoration-line-through text-danger">{`${formatPrice(creditCardNoEntry[0].installmentAmountWithoutSR)}`}</span>
                      <span className="small">{' por'}</span>
                    </p>
                  )
                }
                  {
                  creditCardNoEntry.map(({
                    quantity, installmentAmount,
                  }, index) => (
                    index === creditCardNoEntry.length - 1
                      ? (
                        <p key={installmentAmount} className="text-align-end payment my-1">
                          <span className="text-muted">{`${quantity}x `}</span>
                          <span className="strong">{formatPrice(installmentAmount)}</span>
                        </p>
                      )
                      : (
                        <p key={installmentAmount} className="text-align-end payment my-1">
                          <span className="small text-muted">{`${quantity}x `}</span>
                          <span className="strong">{formatPrice(installmentAmount)}</span>
                          <span className="small text-muted"> ou</span>
                        </p>
                      )
                  ))
                }
                </div>
              </div>
            </>
          )
      }
    </td>
  );
}

export default CreditCardNoEntry;
